import $ from 'jquery';

const selects = document.getElementsByClassName('form-select');

for (let index = 0; index < selects.length; index++) {
  const select = selects[index];
  const value = select.value;
  select.classList.toggle('form-select--placeholder', value.length === 0);
  // use jquery to listen to select2 event
  $(select).on('change', () => {
    const value = select.value;
    select.classList.toggle('form-select--placeholder', value.length === 0);
  })
}
